/** Adressen die per definitie niet terugmailen. */
const NIET_ANTWOORDBAAR = /^(no[._-]?reply|donotreply|do[._-]?not[._-]?reply|noreply)@/i;

/** Bekende formulier- en antwoordservice-relays. */
const RELAY_DOMEINEN = ['@tapijtreiniging-ploeg.nl', '@bizziphone.com'];

/**
 * Een relay is een doorgeefluik, nooit de klant zelf. Deze browserveilige
 * helper wordt gedeeld door bronselectie, UI en de server-ontvangerrangorde.
 */
export function isRelayAdres(email?: string | null): boolean {
  const waarde = (email || '').trim().toLowerCase();
  if (!waarde) return false;
  if (NIET_ANTWOORDBAAR.test(waarde)) return true;
  return RELAY_DOMEINEN.some((domein) => waarde.endsWith(domein));
}
